/* globals Mime */

/** @type {Record<string, Mime.Render>} */
const render = {
	video: 'custom',
	audio: 'custom',
	image: 'custom',
	// pour les pdf, doit être "inline" sinon le viewer PDF de Chrome va télécharger avec le nom du blob...
	pdf: 'inline',
	html: 'custom',
	mail: 'custom',
	json: 'custom',
	text: 'custom',
	zip: 'custom',

	excel: 'none',
	default: 'none',
};

/** @type {any} */
const mime = {
	'video/mp4': 'video',
	'video/x-msvideo': 'video',
	'video/mpeg': 'video',
	'video/ogg': 'video',
	'video/webm': 'video',
	'video/x-matroska': 'video',

	'audio/aac': 'audio',
	'audio/midi': 'audio',
	'audio/x-midi': 'audio',
	'audio/mpeg': 'audio',
	'audio/ogg': 'audio',
	'audio/opus': 'audio',
	'audio/wav': 'audio',
	'audio/x-wav': 'audio',
	'audio/webm': 'audio',
	'audio/x-m4a': 'audio',

	'image/bmp': 'image',
	'image/gif': 'image',
	'image/heic': 'image',
	'image/heif': 'image',
	'image/jpeg': 'image',
	'image/jpg': 'image',
	'image/png': 'image',
	'image/svg+xml': 'image',
	'image/tiff': 'image',
	'image/vnd.microsoft.icon': 'image',
	'image/webp': 'image',

	'application/gzip': 'zip',
	'application/vnd.rar': 'zip',
	'application/x-7z-compressed': 'zip',
	'application/x-rar-compressed': 'zip',
	'application/x-zip-compressed': 'zip',
	'application/zip': 'zip',
	'multipart/x-zip': 'zip',

	'application/pdf': 'pdf',

	'application/json': 'json',
	'application/ld+json': 'json',

	'text/css': 'text',
	'text/csv': 'text',
	'text/html': 'html',
	'text/javascript': 'text',
	'text/plain': 'text',
	'text/xml': 'text',
	'application/x-httpd-php': 'text',
	'application/rtf': 'text',
	'application/xml': 'text',

	// OB: à ma connaissance on n'a pas encore implémenté de viewer Excel !
	// 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'excel',

	'application/vnd.ms-outlook': 'mail',
	'message/rfc822': 'mail',

	default: 'binary',
};

export const getRender = (/** @type {string} */ mimeType) => render[mimeType] ?? render.default;
export const getType = (/** @type {string} */ type) => mime[type] ?? mime.default;

export default mime;
